import { Card } from '../common'

const StatCard = ({ label, value, icon, loading, error }) => (
  <Card variant="stats" padding="p-2" icon={icon}>
    <div>
      <p className="text-sm font-medium text-slate-600">{label}</p>
      <p className="text-lg font-bold text-slate-900">
        {loading ? '...' : (error ? 'Error' : (value ?? '0'))}
      </p>
    </div>
  </Card>
)

const WorkforceStats = ({ 
  fixedTotalEmployeeCount, 
  loading, 
  weeklyAvgUtilization, 
  weeklyUtilizationLoading, 
  weeklyUtilizationError 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
      <StatCard
        label="Employees"
        value={fixedTotalEmployeeCount}
        loading={loading}
        icon={
          <svg className="w-6 h-6 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        }
      />

      <StatCard
        label="Avg Bill Rate"
        value="$0/hr"
        icon={
          <svg className="w-6 h-6 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
          </svg>
        }
      />

      <StatCard
        label="Utilization"
        value={weeklyAvgUtilization?.avg_utilization !== undefined ? `${weeklyAvgUtilization.avg_utilization}%` : undefined}
        loading={weeklyUtilizationLoading}
        error={weeklyUtilizationError}
        icon={
          <svg className="w-6 h-6 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        }
      />
    </div>
  )
}

export default WorkforceStats
